import { render, staticRenderFns } from "./WhatsappButton.vue?vue&type=template&id=24fcc63a&scoped=true"
import script from "./WhatsappButton.vue?vue&type=script&lang=js"
export * from "./WhatsappButton.vue?vue&type=script&lang=js"
import style0 from "./WhatsappButton.vue?vue&type=style&index=0&id=24fcc63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fcc63a",
  null
  
)

export default component.exports